import React from 'react'

import { get, map } from 'lodash'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

function GuidelineTopic({ options, mainSlug }) {
  if (options.length < 1) {
    return <></>
  }
  return (
    <div className="guildline">
      {map(options, (i, key) => (
        <React.Fragment key={key}>
          <h4 className="guildline__header">{get(i, 'label')}</h4>
          <ul className="guildline__list">
            {map(get(i, 'article'), (article, k) => (
              <li className="guildline__item" key={`${key}${k}`}>
                <Link to={`/category/${mainSlug}/${i.slug}/${article.slug}`}>
                  {get(article, 'label')}
                </Link>
              </li>
            ))}
          </ul>
        </React.Fragment>
      ))}
    </div>
  )
}

GuidelineTopic.propTypes = {
  options: PropTypes.array.isRequired,
  mainSlug: PropTypes.string.isRequired,
}

export default GuidelineTopic
